import { createSelector } from 'reselect';

const selectLegendState = (state) => state.legend;

export const selectLegendItems = createSelector([selectLegendState], (state) => state.items);

